import React from 'react';

const TotalGapDiagram = () => {
  return (
    <div className="flex justify-center w-full p-4 font-mono">
      <svg viewBox="0 0 800 250" className="w-full max-w-4xl">
        {/* Main horizontal line */}
        <line x1="20" y1="120" x2="780" y2="120" stroke="black" strokeWidth="1.5" />
        
        {/* Arrow at end of horizontal line */}
        <polygon points="780,120 770,115 770,125" fill="black" />
        
        {/* Left dashed vertical line */}
        <line x1="70" y1="0" x2="70" y2="175" stroke="black" strokeWidth="1.5" strokeDasharray="5,5" />
        
        {/* Right dashed vertical line */}
        <line x1="720" y1="0" x2="720" y2="175" stroke="black" strokeWidth="1.5" strokeDasharray="5,5" />
        
        {/* Total Gap arrow - dark green */}
        <line x1="70" y1="60" x2="720" y2="60" stroke="#004000" strokeWidth="3" />
        <polygon points="720,60 710,55 710,65" fill="#004000" />
        <polygon points="70,60 80,55 80,65" fill="#004000" />
        
        {/* Segment arrows */}
        <line x1="70" y1="180" x2="223" y2="180" stroke="black" strokeWidth="2" />
        <polygon points="203,180 193,175 193,185" fill="black" />
        <polygon points="70,180 80,175 80,185" fill="black" />
        
        <line x1="223" y1="180" x2="327" y2="180" stroke="black" strokeWidth="2" />
        <polygon points="307,180 297,175 297,185" fill="black" />
        <polygon points="203,180 213,175 213,185" fill="black" />
        
        <line x1="327" y1="180" x2="431" y2="180" stroke="black" strokeWidth="2" />
        <polygon points="411,180 401,175 401,185" fill="black" />
        <polygon points="307,180 317,175 317,185" fill="black" />
        
        <line x1="431" y1="180" x2="535" y2="180" stroke="black" strokeWidth="2" />
        <polygon points="505,180 495,175 495,185" fill="black" />
        <polygon points="411,180 421,175 421,185" fill="black" />
        
        <line x1="535" y1="180" x2="639" y2="180" stroke="black" strokeWidth="2" />
        <polygon points="639,180 629,175 629,185" fill="black" />
        <polygon points="505,180 515,175 515,185" fill="black" />
        
        <line x1="639" y1="180" x2="720" y2="180" stroke="black" strokeWidth="2" />
        <polygon points="720,180 710,175 710,185" fill="black" />
        <polygon points="639,180 649,175 649,185" fill="black" />
        
        {/* Labels - Total Gap in dark green */}
        <text x="400" y="30" fontFamily="monospace" fontSize="24" textAnchor="middle" fill="#004000">Total Gap</text>
        
        {/* Left side label */}
        <text x="80" y="15" fontFamily="monospace" fontSize="16" textAnchor="left" fontWeight="bold">Re-Bench</text>
        <text x="80" y="35" fontFamily="monospace" fontSize="16" textAnchor="left" fontWeight="bold">Saturation</text>
        
        {/* Right side label */}
        <text x="615" y="15" fontFamily="monospace" fontSize="16" textAnchor="right" fontWeight="bold">Superhuman</text>
        <text x="665" y="35" fontFamily="monospace" fontSize="16" textAnchor="right" fontWeight="bold">Coder</text>
        
        {/* Bottom segment labels */}
        <text x="135" y="210" fontFamily="monospace" fontSize="14" textAnchor="middle">Time Horizon</text>
        
        <text x="255" y="210" fontFamily="monospace" fontSize="14" textAnchor="middle">Engineering</text>
        <text x="255" y="230" fontFamily="monospace" fontSize="14" textAnchor="middle">Complexity</text>
        
        <text x="359" y="210" fontFamily="monospace" fontSize="14" textAnchor="middle">Feedback</text>
        <text x="359" y="230" fontFamily="monospace" fontSize="14" textAnchor="middle">Loops</text>
        
        <text x="460" y="210" fontFamily="monospace" fontSize="14" textAnchor="middle">Parallel</text>
        <text x="460" y="230" fontFamily="monospace" fontSize="14" textAnchor="middle">Projects</text>
        
        <text x="572" y="210" fontFamily="monospace" fontSize="14" textAnchor="middle">Specialization</text>
        
        <text x="679" y="210" fontFamily="monospace" fontSize="14" textAnchor="middle">Cost and</text>
        <text x="679" y="230" fontFamily="monospace" fontSize="14" textAnchor="middle">Speed</text>
        
        {/* Right side AI progress label */}
        <text x="730" y="140" fontFamily="monospace" fontSize="14" textAnchor="start">AI</text>
        <text x="730" y="155" fontFamily="monospace" fontSize="14" textAnchor="start">progress</text>
        {/* <text x="730" y="198" fontFamily="monospace" fontSize="14" textAnchor="start">months at the</text>
        <text x="730" y="218" fontFamily="monospace" fontSize="14" textAnchor="start">2024 rate of AI</text>
        <text x="730" y="238" fontFamily="monospace" fontSize="14" textAnchor="start">progress)</text> */}
      </svg>
    </div>
  );
};

export default TotalGapDiagram;